import { connect } from 'react-redux';
import {
  setShowTools as showToolsAction,
  markAsResolved,
  clearHistoricalTicket,
  setChatMacroRecommendationsEnabled,
  escalateCurrentTicket,
  openPreviousConversationsSection,
  setEscRecoSeen,
  setActiveEscRecoPopupId,
} from '../actions/index';
import AssignedTicketComponent from '../components/AssignedTicketComponent/AssignedTicketComponent';
import { AVAILABLE } from '../constants/expertAvailability';
import {
  extractSelectedTicketBusinessDetailsFromState,
  extractSelectedHistoricalTicketIdFromState,
  getAllMessages,
  getSelectedAssignedTicketData,
  extractCurrentQueueLength,
  isSpecialistLite,
  shouldDisplayChatMacroRecommendations,
  chatMacroRecommendationsAvailable,
  getTicketRemovalInProcess,
  getIsExpertDashboardOpened,
  isCommerceWizardActive,
  escalationRecommendationMessage,
  extractSelectedTicketFromState,
  getSmbOfSelectedTicket,
  getActiveEscRecoPopupId,
  extractChatUIStatus,
} from '../extractFromState';
import { ROUTING_OUTBOUND, ERROR } from '../constants/messageStatuses';
import { OUTBOUND } from '../constants/messageDirection';
import { SIMPLR_BOT } from '../constants/sources';
import { bindActionCreators } from 'redux';

const getOutboundMessageCount = (conversation, userId) => {
  let outboundMessageCount = 0;
  conversation.allMessages.forEach((messageId) => {
    const message = conversation[messageId];
    if (
      message.expert &&
      message.expert.simplrExpertId === userId &&
      message.direction === OUTBOUND &&
      message.source !== SIMPLR_BOT &&
      !(message.status === ERROR || message.status === ROUTING_OUTBOUND)
    ) {
      outboundMessageCount += 1;
    }
    if (message.noteType === 'ESCALATION_REASON') {
      outboundMessageCount = 0;
    }
  });

  return outboundMessageCount;
};

const mapStateToProps = (state) => {
  const selectedTicket = extractSelectedTicketFromState(state);

  return {
    ticket: selectedTicket,
    currentTicketSMBName: getSmbOfSelectedTicket(state),
    assignedTicketsIds: state.tickets.assignedTickets.allTickets,
    escalationRecommendationMessage: escalationRecommendationMessage(state, selectedTicket),
    selectedTicket: getSelectedAssignedTicketData(state),
    isAdmin: state.user.isAdmin,
    selectedConversation: state.conversation,
    general: (state.ui && state.ui.tools && state.ui.tools.general) || {},
    showButtons: state.user.isAdmin || state.user.availability === AVAILABLE,
    allMessages: getAllMessages(state),
    outboundMessageCount: getOutboundMessageCount(state.conversation, state.user.id),
    businessDetailsForTicket: extractSelectedTicketBusinessDetailsFromState(state),
    isSelectedHistoricalTicket: !!extractSelectedHistoricalTicketIdFromState(state),
    queueLength: extractCurrentQueueLength(state),
    isSpecialistLite: isSpecialistLite(state),
    shouldDisplayChatMacroRecommendations: shouldDisplayChatMacroRecommendations(state),
    chatMacroRecommendationsAvailable: chatMacroRecommendationsAvailable(state),
    chatUIStatus: extractChatUIStatus(state),
    ticketRemovalInProcess: getTicketRemovalInProcess(state),
    isExpertDashboardOpened: getIsExpertDashboardOpened(state),
    isCommerceWizardActive: isCommerceWizardActive(state),
    activeEscRecoPopupId: getActiveEscRecoPopupId(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      markAsResolved,
      clearHistoricalTicket,
      setChatMacroRecommendationsEnabled,
      setShowTools: showToolsAction,
      onMarkAsResolved: markAsResolved,
      expertReviewEscalation: escalateCurrentTicket,
      setEscRecoSeen,
      setActiveEscRecoPopupId,
      openPreviousConversationsSection,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AssignedTicketComponent);
